<template>
  <EditDialog
    v-model:visible="visible"
    :title="
      $t('views.layout.Dialog.ModifyPassword.154c18b9c0bea57368090b4582ef7751')
    "
    :sure-btn-width="120"
    is-show-cancl="true"
    :hide-footer="false"
    :width="440"
    :padding="32"
    :z-index="1001"
    @submit="handleClick"
    @cancel="visible = false"
  >
    <DynamicsForm
      :model="model"
      :label-width="0"
      :setting="baseSetting"
      hide-required-mark
      :group-collapse="false"
    />
  </EditDialog>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { modidyPassword } from '@/api/permission';
import { DynamicsForm } from '@koi-design/vix-components';
import { defineComponent, ref, reactive } from 'vue';
import { checkPw } from '@/libs/reg';
import { message } from '@koi-design/uxd-ui';
import { useStore } from 'vuex';
import md5 from 'md5';

export default defineComponent({
  components: {
    DynamicsForm
  },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const visible = ref(false);
    const model = reactive({
      old_password: '',
      password: '',
      password_confirmation: ''
    });
    const baseSetting = [
      {
        name: 'old_password',
        label: '',
        type: 'password',
        props: {
          placeholder: t(
            'views.layout.Dialog.ModifyPassword.00f6cac45231267efb620934cf1fec60'
          ),
          maxlength: 20
        }
      },
      {
        name: 'password',
        label: '',
        type: 'password',
        props: {
          placeholder: t(
            'views.layout.Dialog.ModifyPassword.fa8ec3161d66f0c99dd8dc5af8b5793d'
          ),
          maxlength: 20
        }
      },
      {
        name: 'password_confirmation',
        label: '',
        type: 'password',
        props: {
          placeholder: t(
            'views.layout.Dialog.ModifyPassword.b8b2530173eb60c04ebf495275216a05'
          ),
          maxlength: 20
        }
      }
    ];
    const show = (flag = true) => {
      visible.value = flag;
    };
    const handleClick = async () => {
      if (!checkPw(model.old_password)) {
        message.error(
          t(
            'views.layout.Dialog.ModifyPassword.5d730c67dfb0302d1791b05c9742f077'
          )
        );
        return;
      }
      if (!checkPw(model.password)) {
        message.error(
          t(
            'views.layout.Dialog.ModifyPassword.d634c639cd3d343b160d6a4d9ea980c2'
          )
        );
        return;
      }
      if (model.password !== model.password_confirmation) {
        message.error(
          t(
            'views.layout.Dialog.ModifyPassword.73e3d2b72de074a389ae3541f937cf7d'
          )
        );
        return;
      }
      const res = await modidyPassword({
        old_password: md5(model.old_password),
        password: md5(model.password),
        password_confirmation: md5(model.password_confirmation),
        user_id: store.getters.botUserInfo.userId
      });
      if (res) {
        visible.value = false;
      }
    };
    return {
      show,
      visible,
      model,
      handleClick,
      baseSetting
    };
  }
});
</script>
